var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.97 2.6543H7.03C4.53 2.6543 2.5 4.6843 2.5 7.1843V12.6443C2.5 15.1443 4.53 17.1743 7.03 17.1743H16.97C19.47 17.1743 21.5 15.1443 21.5 12.6443V7.1843C21.5 4.6843 19.47 2.6543 16.97 2.6543Z",
    fill: "#FF6E42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0095 10.3738C18.0095 10.7938 17.6795 11.1238 17.2595 11.1238H15.0995C14.8295 11.1238 14.5895 10.9838 14.4495 10.7638L14.3495 10.5938L13.1295 13.3038C13.0095 13.5738 12.7395 13.7438 12.4495 13.7438H12.4095C12.0995 13.7338 11.8395 13.5238 11.7395 13.2338L10.4995 9.53383L10.1395 10.6138C10.0395 10.9238 9.74949 11.1238 9.42949 11.1238H6.72949C6.31949 11.1238 5.97949 10.7938 5.97949 10.3738C5.97949 9.96383 6.31949 9.62383 6.72949 9.62383H8.88949L9.78949 6.93383C9.88949 6.63383 10.1795 6.42383 10.4995 6.42383C10.8195 6.42383 11.1095 6.63383 11.2095 6.93383L12.5495 10.9438L13.5795 8.66383C13.6895 8.41383 13.9395 8.24383 14.2195 8.22383C14.5095 8.20383 14.7595 8.35383 14.8995 8.59383L15.5195 9.62383H17.2595C17.6795 9.62383 18.0095 9.96383 18.0095 10.3738Z",
    fill: "#FF6E42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9427 19.8458H15.3897L14.9597 17.1748H13.4297L13.8697 19.8448L10.1297 19.8458L10.5597 17.1748H9.03971L8.60971 19.8448L7.05371 19.8458C6.63971 19.8458 6.30371 20.1818 6.30371 20.5958C6.30371 21.0098 6.63971 21.3458 7.05371 21.3458H16.9427C17.3567 21.3458 17.6927 21.0098 17.6927 20.5958C17.6927 20.1818 17.3567 19.8458 16.9427 19.8458Z",
    fill: "#FF6E42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0095 10.3738C18.0095 10.7938 17.6795 11.1238 17.2595 11.1238H15.0995C14.8295 11.1238 14.5895 10.9838 14.4495 10.7638L14.3495 10.5938L13.1295 13.3038C13.0095 13.5738 12.7395 13.7438 12.4495 13.7438H12.4095C12.0995 13.7338 11.8395 13.5238 11.7395 13.2338L10.4995 9.53383L10.1395 10.6138C10.0395 10.9238 9.74949 11.1238 9.42949 11.1238H6.72949C6.31949 11.1238 5.97949 10.7938 5.97949 10.3738C5.97949 9.96383 6.31949 9.62383 6.72949 9.62383H8.88949L9.78949 6.93383C9.88949 6.63383 10.1795 6.42383 10.4995 6.42383C10.8195 6.42383 11.1095 6.63383 11.2095 6.93383L12.5495 10.9438L13.5795 8.66383C13.6895 8.41383 13.9395 8.24383 14.2195 8.22383C14.5095 8.20383 14.7595 8.35383 14.8995 8.59383L15.5195 9.62383H17.2595C17.6795 9.62383 18.0095 9.96383 18.0095 10.3738Z",
    fill: "#FF6E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpIcon);
export default __webpack_public_path__ + "static/media/follow_up_icon.c3889334be9bca42fe3440958a1982c0.svg";
export { ForwardRef as ReactComponent };